import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export async function startCheckout(packageId, user, navigate) {
  if (!user) {
    navigate("/auth", { state: { buy: packageId } });
    return;
  }
  try {
    const { data } = await api.post("/payments/checkout", {
      package_id: packageId,
      origin_url: window.location.origin,
    });
    window.location.href = data.checkout_url;
  } catch (e) {
    toast.error(formatApiError(e));
  }
}
